import React from "react";
import { AlertTriangle } from "lucide-react";

export default function AllergyWarning() {
  return (
    <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
      <p className="leading-relaxed">
        <strong>Food Allergy Notice:</strong> Food items on PrepMate are prepared and supplied by independent vendors. PrepMate does not prepare or handle food products. Vendors are responsible for ingredients, preparation practices, and allergen disclosures. Food products may contain common allergens including but not limited to dairy, eggs, wheat, soy, peanuts, tree nuts, fish, or shellfish. If you have food allergies or dietary restrictions, please contact the vendor directly before placing your order.
      </p>
    </div>
  );
}
